import { ApiComponentType, GroupedComponents } from "@store/types";

export const getGroupedComponents = (components: ApiComponentType[]): GroupedComponents =>
    components.reduce<GroupedComponents>(
        (acc, component) =>
            component.group
                ? {
                      ...acc,
                      [component.name]: components.filter((c) =>
                          component.components?.includes(c.id),
                      ),
                  }
                : acc,
        {},
    );
